import type { StyleRule } from '@archipro-design/aria';
import {
    captionClassName,
    labelClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

/**
 * px values are intentional because this button aligns to a fixed page offset.
 */
export const BackToTopButton: StyleRule = ({ theme }) => ({
    width: '60px',
    height: '60px',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '12px',
    [theme.screen.tablet]: {
        [`& .${labelClassName}`]: {
            marginTop: '6px',
            fontSize: '11px',
            lineHeight: '200%',
        },
        [`& .${svgIconClassName}`]: {
            transform: 'rotate(90deg)',
            width: '16px',
            height: '10px',
        },
    },
});

export const AOCSectionContainer: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.colors.white['100A'],
});

export const AOCSection: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([60, 50]),
    maxWidth: pxToRem(1920),

    [`& .${captionClassName}`]: {
        display: 'block',
        maxWidth: pxToRem(700),
        lineHeight: theme.siteVariables.lineHeightSmaller,
        letterSpacing: theme.siteVariables.letterSpacingSmall,
        color: '#0D0E12',
    },
    [theme.screen.clamped]: {
        paddingLeft: `max(0px, calc(${pxToRem(1920 + 50)} - 100vw))`,
        margin: 'auto',
    },
});
